import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const useGoBack = () => {
  const navigate = useNavigate();
  const goBackHandler = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return goBackHandler;
};

export default useGoBack;
